<template>
    <div style="position: relative;">
        <div class="backOuter" :style="{width:width+'px'}">
            <img style="width: 100%"
                :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/background.png'" />
        </div>
        <div class="img">
            <img style="width: 150px;height: 150px"
                :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/parent.png'" />
            <div id="qrcode" ref="qrcode" style="width: 150px;height: 150px;margin-top: 200px;z-index: 99999;"></div>
        </div>
        <div class="content">
            <div class="content-item1">
                <img style="width: 30px;height: 30px;margin-top: 7px;margin-right: 5px"
                    :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/robot.png'" />
                <div class="title">鹦果家长版</div>
            </div>
            <div class="content-item1" :style="{marginLeft:width2+'px',marginTop: '20px'}">
                扫描二维码下载，或点击下方按钮下载
            </div>
            <div style="margin-left: 35%;width: 30%;">
                <a-divider />
            </div>
            <div class="content-item2">
                {{constants.versionName}} (Build {{constants.versionCode}}) - {{constants.versionMinCode}} MB
            </div>
            <div class="content-item2">
                更新于:{{$dateFormat(constants.updateAt)}}
            </div>
            <div class="content-item2" style="margin-top: 30px">
                <a-button type="primary" class="button" @click="gotoDownLoad">下载安装</a-button>
            </div>
            <div style="margin-left: 30%;width: 50%;margin-top: 30px">
                <a-divider />
            </div>
            <div class="content-item1" :style="{marginLeft:width2+'px',marginTop: '20px'}">
                <span style="font-weight: 600">更新日志：</span>{{constants.changeLog}}
            </div>
        </div>
    </div>
</template>
<script>
    import { gateway } from '@/api/gateway'
    import QRCode from 'qrcodejs2'
    export default {
        data() {
            return {
                constants: {},
                code: '',
                downLoadUrl: '',
                width: '',
                width2: '',
                imgWidth: ''
            };
        },
        created() {
            if (this.isMobile()) {
                this.$router.push({
                    path: '/parent',
                })
            }
            this.width = document.body.clientWidth
            this.width2 = this.width * 0.35 + 30
            this.imgWidth = (this.width - 350) / 2
            console.log('屏幕宽度', this.width)
            this.init()
        },
        mounted() {
            document.title = '鹦果家长版'
        },
        methods: {
            isMobile() {
                let userAgentInfo = navigator.userAgent;
                let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
                let getArr = Agents.filter(i => userAgentInfo.includes(i));
                return getArr.length ? true : false;
            },
            init() {
                gateway('getAppVersion', { appType: 1, platformType: 0 }).then(res => {
                    console.log(res.data.list[0]);
                    this.constants = res.data.list[0]
                    this.downLoadUrl = res.data.list[0].downloadUrl
                    this.qrcodeScan()
                })
            },
            gotoDownLoad() {
                window.location.href = this.downLoadUrl
            },
            qrcodeScan() { //生成二维码
                console.log('a', this.downLoadUrl);
                let qrcode = new QRCode(document.getElementById("qrcode"), {
                    width: 150, // 二维码宽度 
                    height: 150, // 二维码高度
                    text: this.downLoadUrl, // 浏览器地址url
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H,
                })
            },
        }
    };
</script>
<style src="./index.css" />